import React from 'react';
import { Box, Button } from '@mui/material';
import { BRAND_ORANGE } from '../../../../styles/brandSwitchStyles';

const outlinedSx = {
  textTransform: 'none',
  fontWeight: 700,
  minWidth: 120,
  borderRadius: '20px',
  color: BRAND_ORANGE,
  borderColor: BRAND_ORANGE,
  borderWidth: 1.5,
  '&:hover': {
    borderColor: 'primary.dark',
    borderWidth: 1.5,
    bgcolor: 'rgba(224, 104, 10, 0.04)',
  },
};

const containedSx = {
  textTransform: 'none',
  fontWeight: 700,
  minWidth: 140,
  borderRadius: '20px',
  bgcolor: BRAND_ORANGE,
  boxShadow: 'none',
  '&:hover': { bgcolor: 'primary.dark', boxShadow: 'none' },
};

const ManageEventActions = ({
  activeStep,
  isLastStep,
  isEditMode,
  submittingAction = null,
  submitDisabled = false,
  requiresSaveAs = false,
  partnerDraftEdit = false,
  partnerNonDraftEdit = false,
  createSubmitLabel = 'Publish Event',
  draftSubmitLabel = 'Save as Draft',
  editDraftSubmitLabel = 'Save Changes as Draft',
  editSaveChangesLabel = 'Save Changes',
  onCancel,
  onBack,
  onNext,
  onSubmit,
}) => {
  const isSubmitting = Boolean(submittingAction);

  const renderPartnerLastStepActions = () => {
    if (partnerDraftEdit) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Button
            variant="outlined"
            disabled={isSubmitting || submitDisabled}
            onClick={() => onSubmit('save-changes')}
            sx={outlinedSx}
          >
            {submittingAction === 'save-changes' ? 'Saving…' : editDraftSubmitLabel}
          </Button>
          <Button
            variant="contained"
            disabled={isSubmitting || submitDisabled}
            onClick={() => onSubmit('submit')}
            sx={containedSx}
          >
            {submittingAction === 'submit' ? 'Submitting…' : createSubmitLabel}
          </Button>
        </Box>
      );
    }

    if (partnerNonDraftEdit) {
      return (
        <Button
          variant="contained"
          disabled={isSubmitting || submitDisabled}
          onClick={() => onSubmit('submit')}
          sx={containedSx}
        >
          {submittingAction === 'submit' ? 'Saving…' : editSaveChangesLabel}
        </Button>
      );
    }

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Button
          variant="outlined"
          disabled={isSubmitting || submitDisabled}
          onClick={() => onSubmit('draft')}
          sx={outlinedSx}
        >
          {submittingAction === 'draft' ? 'Saving…' : draftSubmitLabel}
        </Button>
        <Button
          variant="contained"
          disabled={isSubmitting || submitDisabled}
          onClick={() => onSubmit('submit')}
          sx={containedSx}
        >
          {submittingAction === 'submit' ? 'Submitting…' : createSubmitLabel}
        </Button>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 4,
        pt: 3,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Button
        variant="outlined"
        disabled={isSubmitting}
        onClick={activeStep === 0 ? onCancel : onBack}
        sx={outlinedSx}
      >
        {activeStep === 0 ? 'Cancel' : 'Back'}
      </Button>

      {requiresSaveAs && isLastStep ? (
        renderPartnerLastStepActions()
      ) : (
        <Button
          type="button"
          variant="contained"
          disabled={isSubmitting || (isLastStep && submitDisabled)}
          onClick={isLastStep ? () => onSubmit('submit') : onNext}
          sx={containedSx}
        >
          {submittingAction === 'submit'
            ? 'Saving…'
            : isLastStep
              ? isEditMode
                ? 'Save Changes'
                : createSubmitLabel
              : 'Next Step'}
        </Button>
      )}
    </Box>
  );
};

export default ManageEventActions;
